    
export default class IndicadorDashboard {
    titulo: string;
    alvo: string;
	valor: number;

    constructor(titulo: string, alvo: string, valor: number) {
        this.titulo = titulo;
        this.alvo = alvo;
        this.valor = valor;
    }
}